import React, { useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import "./NavBar.css"; // Assuming you have a separate CSS file for Navbar styles

const NavBar = () => {
  const history = useHistory();
  const { state, dispatch } = useContext(UserContext);

  const handleLogout = () => {
    localStorage.clear();
    dispatch({ type: "CLEAR" });
    history.push("/signin");
  };

  return (
    <nav className="navbar">
      <div className="nav-wrapper">
        <img
          src="https://image.pbs.org/bento3-prod/mpt-bento-live-pbs/main/16a2473dc6_mpt_header_logo_medium3.png?resize=640x,no-scale-up"
          alt="MPT Logo"
          className="logo"
        />
        <ul className="nav-links">
          {state && (
            <>
              <li>{/* <Link to="/createpost">Create Post</Link> */}</li>
              <li onClick={handleLogout}>Logout</li>
            </>
          )}
          {!state && (
            <li>
              <Link to="/signin">Sign In</Link>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
